// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gL","advertCardFooter__row":"c-a_gM","advertCardFooter__name":"c-a_gN","advertCardFooter__price":"c-a_gO","advertCardFooter__age":"c-a_gP"};